export const company = {
  name: 'Matthias Klob GmbH',
  shortName: 'Matthias Klob',
  legalForm: 'GmbH',
  phone: '0160 7607447',
  phoneHref: 'tel:+491607607447',
  email: 'matthias-klob@gmx.de',
  street: 'Krögelstein 93',
  city: '96142 Hollfeld-Krögelstein',
  region: 'Bayern',
  rating: '4,4',
  reviewCount: 5,
  founded: 'Handwerk aus Hollfeld',
  tagline: 'Putz-, Ausbau- und Handwerksarbeiten aus Hollfeld — sauber, zuverlässig und fachgerecht umgesetzt.',
  mapsDirectionsUrl: 'https://www.google.com/maps/dir/?api=1&destination=Kr%C3%B6gelstein%2093%2C%2096142%20Hollfeld',
};